const normalizeCompanyId = (companyId: string | null | undefined): string | null => {
    const normalizedCompanyId = companyId?.trim().toLowerCase()

    return normalizedCompanyId || null
}

export const areCompanyIdsEqual = (
    firstCompanyId: string | null | undefined,
    secondCompanyId: string | null | undefined
): boolean => {
    const normalizedFirstCompanyId = normalizeCompanyId(firstCompanyId)
    const normalizedSecondCompanyId = normalizeCompanyId(secondCompanyId)

    return normalizedFirstCompanyId !== null && normalizedFirstCompanyId === normalizedSecondCompanyId
}
